import React from "react";
import { Box, Divider, Text, Group } from "@mantine/core";

import { FILTER_INPUT_COMPONENTS } from "./inputs";

import { displayEmoji } from "../../../../utils/Emoji";

export default function MemberFilterList({ type, data = [], isEditMode, onCreateMemberFilter, onUpdateMemberFilter, onRemoveMemberFilter }) {
  if (!Array.isArray(data) || data.length === 0) return null;

  const filteredData = isEditMode ? data : data.filter((item) => !!item.value);
  const visibilityData = isEditMode ? filteredData : filteredData.filter((item) => {
    const _visibility = Array.isArray(item.visibility) ? item.visibility : ["all"];
    return (_visibility.includes(type) || _visibility.includes("all"));
  });

  return (
    <Box>
      {visibilityData.length > 0 && <Divider my={20} />}

      {visibilityData.map((item, index) => {
        const Component = FILTER_INPUT_COMPONENTS[item.format];
        const _value = typeof item.value === "string" ? item.value : "";
        const _selectedOptions = _value.length ? [_value] : [];
        return (
          <Box key={index} mb={15}>
            <Group spacing={0} mb={5}>
              {displayEmoji(item.emojicon, "grey")}
              <Text color="grey" transform="uppercase" ml={5}>{item.name}</Text>
            </Group>
            {Component ? (
              <Component
                value={_value}
                isEditMode={isEditMode}
                options={item.options}
                color={item.color}
                selectedOptions={_selectedOptions}
                onChange={(new_value) => {
                  if (item.member_filter_id) {
                    if (typeof onUpdateMemberFilter === "function") {
                      onUpdateMemberFilter(item.id, item.member_filter_id, new_value);
                    }
                  } else {
                    if (typeof onCreateMemberFilter === "function") {
                      onCreateMemberFilter(item.id, new_value);
                    }
                  }
                }}
                onClickRemove={item.member_filter_id && isEditMode ? () => {
                  if (typeof onRemoveMemberFilter === "function") {
                    onRemoveMemberFilter(item.member_filter_id);
                  }
                } : undefined}
              />
            ) : null}
          </Box>
        )
      })}

    </Box>
  );
}